import PropTypes from "prop-types"
import { get } from "lodash"
import classnames from "classnames"
import { OPTIONAL_CHART_ITEM } from "helpers/shapes"
import "./style.scss"

function getValue(data, index, formatter) {
  const value = get(data, [index, "value"])

  if (value === undefined || value == null || Number.isNaN(value)) {
    return "N/A"
  } else {
    return formatter(value)
  }
}

function SelectedTooltipItem({ index, data, label, formatter, id, currentId, driftIcon }) {
  return <div className={classnames("components_charts_selected-tooltip-item", { selected: id === currentId })}>
    <span className="dimension">{label}</span>
    <span className="value">{getValue(data, index, formatter)}</span>
    {driftIcon && <span>{driftIcon}</span>}
  </div>
}

SelectedTooltipItem.propTypes = {
  id: PropTypes.string.isRequired,
  currentId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(OPTIONAL_CHART_ITEM).isRequired,
  label: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
  driftIcon: PropTypes.element,
}

export default SelectedTooltipItem
